export function showMoreIngredients() {
    $('.show-more-allergen').on('click', function () {
        const $this = $(this);
        const hiddenInfo = $this.closest('.allergen-guide').find('.hidden-info');
        if ($this.hasClass('active')) {
            $this.text('view more info');
            hiddenInfo.slideUp();
            $this.removeClass('active');
        } else {
            $this.text('view less info');
            hiddenInfo.slideDown();
            $this.addClass('active');
        }
    });

    $('.show-more-ingredients').on('click', function () {
        const $this = $(this);
        const hiddenInfo = $this.closest('.ingredients-section').find('.ingredients-hidden');
        if ($this.hasClass('active')) {
            $this.text('View all ingredients');
            hiddenInfo.slideUp();
            $this.removeClass('active');
        } else {
            $this.text('close all ingredients');
            hiddenInfo.slideDown();
            $this.addClass('active');
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/showMoreIngredients.js